module.exports = __webpack_public_path__ + "img/bgtips.11a71386.png";